import { render, staticRenderFns } from "./khusus.vue?vue&type=template&id=64e7b37a&"
import script from "./khusus.vue?vue&type=script&lang=js&"
export * from "./khusus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports